import React from 'react'
import { Link } from 'react-router-dom';
import Shape02 from '../../../assets/images/services/personal.png';
import Shape03 from '../../../assets/images/services/debt.png';
import Shape04 from '../../../assets/images/services/money-bag.png';
import Shape05 from '../../../assets/images/services/mortarboard.png';
import Shape06 from '../../../assets/images/services/mortgage-loan.png';
import Shape07 from '../../../assets/images/services/loan.png';


const Servicedata = [
    {
        Image: "flaticon-evaluate",
        
        heading: "1. Understanding The Problem",
        content: "Our team is dedicated to giving you our full attention from the very beginning of our interaction. We take the time to listen to your story as if it were our own, thoroughly understanding the root of the problem. This approach allows us to provide precise and tailored consultations."
    },
    {
        Image: "flaticon-expert",
    
        heading: "2. Extensive Research",
        content: "At NRI Advisors, our team excels at making strategic compromises, but never at the expense of thorough research. We guarantee timely action and prompt responses, yet our utmost priorities are precision and depth of knowledge. Here, you will always receive comprehensive, well-researched insights into your issues, striking a perfect balance of speed and accuracy like nowhere else."
    },
    {
        Image: "flaticon-resume",
     
        heading: "3. Strategy And Planning",
        content: "A famous saying goes: 'Some battles must be lost to win the war', At NRI Advisors, we take a different approach. We meticulously craft a strategy to ensure no battles are lost and that the advantage remains firmly in our hands. Our team tirelessly evaluates all possible options, comparing and selecting the best paths to meet our clients' needs.",
    },
    {
        Image: "flaticon-expert-1",
      
        heading: "4. Legal Proceedings",
        content: "With our team of experienced professionals, we will handle all proceedings in India with your input from abroad, maintaining strict confidentiality and ensuring that you are represented by the best team."
    },
    {
        Image: "flaticon-brainstorming",
        
        heading: "5. Transparency And Confidentiality",
        content: "We hold the utmost regard for each individual's privacy. Your data will never be disclosed to a third party without your consent. You will always be kept informed about your case and the progress of our efforts to deliver effective solutions."
    },
    {
        Image: "flaticon-active",
      
        heading: "6. Cultural Understanding",
        content: "We understand the emotions, expectations, and values tied to India for every NRI. Our work reflects a deep respect for both heritage and the realities of living abroad."
    },
]
const Servicesone = () => {
    return (
        <section className="services-section-one mt-5" >
            {/* <div className="service-one-shape-1">
                <img src={Shape01} alt="shape" />
            </div>
            <div className="service-one-shape-2">
                <img src={Shape00} alt="shape" />
            </div> */}
            <div className="container ">
                {/* <div className="row">
                    <div className="col-lg-8 m-auto">
                        <div className="heading-box text-center">
                            <span className="heading-subtitle wow fadeInUp animated animated">
                                🤝 OUR SERVICES
                            </span>
                            <h2 className="heading-title wow fadeInUp animated animated mb-0 pb-0">
                            Local Expertise. Global Impact.
                            </h2>
                            <h6 className='mt-0 pt-0 mb-10 pb-5'>COMPREHENSIVE ARRAY OF SERVICES</h6>
                        </div>
                    </div>
                </div> */}
                <div className="service-one-inner1 " style={{
    border: "1px solid #F2F4F8"
  }}>
                    {Servicedata.map((data, index) => (
                        <div key={index} className="service-one-box1" style={{
                            border: "1px solid #F2F4F8"
                          }}>
                            {/* <div className="service-one-box-image">
                                <img
                                    src={data.bg} alt="service images"
                                />
                            </div> */}
                            <div className="service-one-icon-box">
                                {/* <img src={data.Image} className="flaticon-personal w-50 h-50 object-cover" alt="icon" /> */}
                                <i className={data.Image}/>
                            </div>
                            <div className="service-one-info1">
                                <h4>{data.heading}</h4>
                                <p>
                                    {data.content}
                                </p>
                            </div>
                            {/* <Link to="/Servicesdetails" className="read-more-btn">
                                <i className="flaticon-next" />
                            </Link> */}
                        </div>
                    ))}
                </div>
                {/* <div className="text-center">
                    <Link to="/Services1" className="btn btn-secondary">
                        View More
                        <i className="flaticon-personal" />
                    </Link>
                </div> */}
            </div>
        </section>

    )
}
export default Servicesone;